import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import cn from "classnames";

export type DropdownItem = {
  title: string;
  value: string | null;
  onSelect: () => void;
};

type Props = {
  disabled?: boolean;
  className?: string;
  children: any;
  items: DropdownItem[];
};

export const Dropdown: React.FC<Props> = ({
  items,
  disabled = false,
  className,
  children,
}) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button
          disabled={disabled}
          style={{ borderWidth: "1px" }}
          className={cn(
            "inline-flex justify-center items-center w-full rounded-md border-gray-300 shadow-sm px-4 py-2 dark:bg-neutral-800 dark:border-neutral-500 text-sm font-medium disabled:opacity-50 hover:bg-gray-50 focus:outline-none",
            className,
          )}
        >
          {children}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-bottom-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1 dark:text-white dark:bg-neutral-800">
            {items.map((item) => {
              return (
                <Menu.Item key={item.value}>
                  <span
                    onClick={item.onSelect}
                    className={"c block w-full text-left px-4 py-2 text-sm"}
                  >
                    {item.title}
                  </span>
                </Menu.Item>
              );
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
